module.exports = "<div class=\"container text-right\">\n  <app-bread-crumb>\n    <li class=\"active\">개인정보 처리방침</li>\n  </app-bread-crumb>\n</div>\n\n<div class=\"container title\">\n  <h1 class=\"title-h1 text-center heyground-font\">개인정보 처리방침</h1>\n  <hr class=\"title-underline center-block\">\n</div>\n<div class=\"container plan\">\n  <h3 class=\"plan__h3 right-line\">개인정보 처리방침</h3>\n  <br>\n  <div [innerHtml]=\"privacy | safeHtml\"></div>\n  <br>\n  <br>\n  <br>\n  <br>\n  <br>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/privacy.component.html
// module id = 1135
// module chunks = 0